import React from 'react'
import { Translate } from 'react-redux-i18n'
import { SCREEN } from '../../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Content } from './Content'
import { Tab } from './Tab'
import { YearTab } from './YearTab'

export const ChartIndustry = () => {
  const { formatedUnit } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  return (
    <div className="w50 h100 flexColumn">
      <div className="dFlex justifyContentBetween mb2">
        <Translate
          value="industryOverview.macroeconomics.GDP_BY_INDUSTRIES"
          className="fw600"
        />
        <Tab />
      </div>
      <YearTab />

      <div className="flex1">
        <Content />
      </div>

      <div
        style={{ position: 'fixed', top: -1000, left: -2000, width: 1600 }}
        id="macroDGPChartIndustryId"
      >
        <Content yAxisWidth={900} height={600} />
      </div>

      <div className="dFlex justifyContentEnd">{formatedUnit}</div>
    </div>
  )
}
